export default {
  id: 'email_leaderboard_overall',
  title: 'Leaderboard Overall',
  type: 'Group',
  subject: 'Leaderboard standings',
  description: 'Current status of the leaderboard.',
  mjml: `<mjml>
  <mj-body>
    <mj-section>
      <mj-column>

        <mj-image src="[[INPUT_BANNER_IMAGE]]"></mj-image>

        <mj-text font-size="14px" line-height="1.5" font-family="helvetica">[[INPUT_INTRODUCTION_TEXT]]</mj-text>
        
        <mj-divider></mj-divider>
      </mj-column>
    </mj-section>
    <mj-section>
      <mj-column width="80%">
        <mj-table padding="0" padding-bottom="10px">
          <tr style="border: 0; background-color:rgba(0, 0, 0, 0);">
      <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);" width="24px">🥇</td>
      <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">{{LEADERBOARD_FIRST_NAME}}</td>
      <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">{{LEADERBOARD_FIRST_POINTS}} points</td>
    </tr>
    <tr style="border: 0; background-color:rgba(0, 0, 0, 0);">
      <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);" width="24px">🥈</td>
      <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">{{LEADERBOARD_SECOND_NAME}}</td>
      <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">{{LEADERBOARD_SECOND_POINTS}} points</td>
    </tr>
    <tr style="border: 0; background-color:rgba(0, 0, 0, 0);">
      <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);" width="24px">🥉</td>
      <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">{{LEADERBOARD_THIRD_NAME}}</td>
      <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">{{LEADERBOARD_THIRD_POINTS}} points</td>
    </tr>
        </mj-table>
      </mj-column>
    </mj-section>
    <mj-section>
      <mj-column>
        
        <mj-divider></mj-divider>

        <mj-text font-size="14px" line-height="1.5" font-family="helvetica">[[INPUT_END_TEXT]]</mj-text>

      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`,
  body: `<!doctype html>
  <html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
  
  <head>
    <title>
    </title>
    <!--[if !mso]><!-->
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <!--<![endif]-->
    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <style type="text/css">
      #outlook a {
        padding: 0;
      }
  
      body {
        margin: 0;
        padding: 0;
        -webkit-text-size-adjust: 100%;
        -ms-text-size-adjust: 100%;
      }
  
      table,
      td {
        border-collapse: collapse;
        mso-table-lspace: 0pt;
        mso-table-rspace: 0pt;
      }
  
      img {
        border: 0;
        height: auto;
        line-height: 100%;
        outline: none;
        text-decoration: none;
        -ms-interpolation-mode: bicubic;
      }
  
      p {
        display: block;
        margin: 13px 0;
      }
    </style>
    <!--[if mso]>
          <noscript>
          <xml>
          <o:OfficeDocumentSettings>
            <o:AllowPNG/>
            <o:PixelsPerInch>96</o:PixelsPerInch>
          </o:OfficeDocumentSettings>
          </xml>
          </noscript>
          <![endif]-->
    <!--[if lte mso 11]>
          <style type="text/css">
            .mj-outlook-group-fix { width:100% !important; }
          </style>
          <![endif]-->
    <!--[if !mso]><!-->
    <link href="https://fonts.googleapis.com/css?family=Ubuntu:300,400,500,700" rel="stylesheet" type="text/css">
    <style type="text/css">
      @import url(https://fonts.googleapis.com/css?family=Ubuntu:300,400,500,700);
    </style>
    <!--<![endif]-->
    <style type="text/css">
      @media only screen and (min-width:480px) {
        .mj-column-per-100 {
          width: 100% !important;
          max-width: 100%;
        }
  
        .mj-column-per-80 {
          width: 80% !important;
          max-width: 80%;
        }
      }
    </style>
    <style media="screen and (min-width:480px)">
      .moz-text-html .mj-column-per-100 {
        width: 100% !important;
        max-width: 100%;
      }
  
      .moz-text-html .mj-column-per-80 {
        width: 80% !important;
        max-width: 80%;
      }
    </style>
    <style type="text/css">
      @media only screen and (max-width:480px) {
        table.mj-full-width-mobile {
          width: 100% !important;
        }
  
        td.mj-full-width-mobile {
          width: auto !important;
        }
      }
    </style>
  </head>
  
  <body style="word-spacing:normal;">
    <div style="">
      <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->
      <div style="margin:0px auto;max-width:600px;">
        <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;">
          <tbody>
            <tr>
              <td style="direction:ltr;font-size:0px;padding:20px 0;text-align:center;">
                <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]-->
                <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                  <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                    <tbody>
                      <tr>
                        <td align="center" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                          <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;">
                            <tbody>
                              <tr>
                                <td style="width:550px;">
                                  <img height="auto" src="[[INPUT_BANNER_IMAGE]]" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="550" />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                          <div style="font-family:helvetica;font-size:14px;line-height:1.5;text-align:left;color:#000000;">[[INPUT_INTRODUCTION_TEXT]]</div>
                        </td>
                      </tr>
                      <tr>
                        <td align="center" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                          <p style="border-top:solid 4px #000000;font-size:1px;margin:0px auto;width:100%;">
                          </p>
                          <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" style="border-top:solid 4px #000000;font-size:1px;margin:0px auto;width:550px;" role="presentation" width="550px" ><tr><td style="height:0;line-height:0;"> &nbsp;
  </td></tr></table><![endif]-->
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!--[if mso | IE]></td></tr></table><![endif]-->
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->
      <div style="margin:0px auto;max-width:600px;">
        <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;">
          <tbody>
            <tr>
              <td style="direction:ltr;font-size:0px;padding:20px 0;text-align:center;">
                <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:480px;" ><![endif]-->
                <div class="mj-column-per-80 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                  <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                    <tbody>
                      <tr>
                        <td align="left" style="font-size:0px;padding:0;padding-bottom:10px;word-break:break-word;">
                          <table cellpadding="0" cellspacing="0" width="100%" border="0" style="color:#000000;font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:13px;line-height:22px;table-layout:auto;width:100%;border:none;">
                            <tr style="border: 0; background-color:rgba(0, 0, 0, 0);">
                              <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);" width="24px">🥇</td>
                              <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">{{LEADERBOARD_FIRST_NAME}}</td>
                              <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">{{LEADERBOARD_FIRST_POINTS}} points</td>
                            </tr>
                            <tr style="border: 0; background-color:rgba(0, 0, 0, 0);">
                              <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);" width="24px">🥈</td>
                              <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">{{LEADERBOARD_SECOND_NAME}}</td>
                              <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">{{LEADERBOARD_SECOND_POINTS}} points</td>
                            </tr>
                            <tr style="border: 0; background-color:rgba(0, 0, 0, 0);">
                              <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);" width="24px">🥉</td>
                              <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">{{LEADERBOARD_THIRD_NAME}}</td>
                              <td style="border: 0; padding: 6px; background-color:rgba(0, 0, 0, 0);">{{LEADERBOARD_THIRD_POINTS}} points</td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!--[if mso | IE]></td></tr></table><![endif]-->
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!--[if mso | IE]></td></tr></table><table align="center" border="0" cellpadding="0" cellspacing="0" class="" style="width:600px;" width="600" ><tr><td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->
      <div style="margin:0px auto;max-width:600px;">
        <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;">
          <tbody>
            <tr>
              <td style="direction:ltr;font-size:0px;padding:20px 0;text-align:center;">
                <!--[if mso | IE]><table role="presentation" border="0" cellpadding="0" cellspacing="0"><tr><td class="" style="vertical-align:top;width:600px;" ><![endif]-->
                <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                  <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                    <tbody>
                      <tr>
                        <td align="center" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                          <p style="border-top:solid 4px #000000;font-size:1px;margin:0px auto;width:100%;">
                          </p>
                          <!--[if mso | IE]><table align="center" border="0" cellpadding="0" cellspacing="0" style="border-top:solid 4px #000000;font-size:1px;margin:0px auto;width:550px;" role="presentation" width="550px" ><tr><td style="height:0;line-height:0;"> &nbsp;
  </td></tr></table><![endif]-->
                        </td>
                      </tr>
                      <tr>
                        <td align="left" style="font-size:0px;padding:10px 25px;word-break:break-word;">
                          <div style="font-family:helvetica;font-size:14px;line-height:1.5;text-align:left;color:#000000;">[[INPUT_END_TEXT]]</div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!--[if mso | IE]></td></tr></table><![endif]-->
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!--[if mso | IE]></td></tr></table><![endif]-->
    </div>

    <!-- %%SIGNATURE%% -->
  </body>
  
  </html>`,
  inputs: {
    INPUT_BANNER_IMAGE: {
      label: 'Banner Image',
      type: 'FILE',
      options: {
        showPreview: true,
        type: 'IMAGE',
        defaultValue: null
      }
    },
    INPUT_INTRODUCTION_TEXT: {
      label: 'Intro',
      placeholder: 'Hi all, ...',
      defaultValue: '<p>Hi all,</p><p>Please find the current status of the leaderboard below.</p>',
      type: 'HTML'
    },
    INPUT_END_TEXT: {
      label: 'Text after leaderboard',
      type: 'HTML',
      placeholder: 'Do not forget that every activity on the platform gets...',
      defaultValue: '<p>Do not forget that every activity on the platform gets can help you win some awesome rewards.</p><p>Thanks for your support!</p>',
    },
  }
};


// WEBPACK FOOTER //
// ./src/views/campaign-admin/templates/emails/leaderboardOverall.js